export default function NoteTargetSelectionController($mdDialog) {
    "ngInject";
    var vm = this;
    var selectedActivity = null;

    vm.closeDialog = $mdDialog.cancel;
    vm.confirmSelection = confirmSelection;
    vm.skipSelection = skipSelection;
    vm.isActivitySelected = isActivitySelected;
    vm.onActivitySelectionChange = onActivitySelectionChange;

    function onActivitySelectionChange(selectedActivities) {
        selectedActivity = selectedActivities?.[0] ?? null;
    }

    function isActivitySelected() {
        return Boolean(selectedActivity);
    }

    function confirmSelection() {
        if (!selectedActivity) {
            return;
        }

        $mdDialog.hide(selectedActivity);
    }

    function skipSelection() {
        $mdDialog.hide(null);
    }
}
